import { EstimatePortActionTypes, PortActionTypeLabels, PortActionTypes } from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';

export const manualEstimatePurposes: Values<typeof EstimatePortActionTypes>[] = [
	EstimatePortActionTypes.BUNKER_STEM,
	EstimatePortActionTypes.CANAL_TRANSIT,
	EstimatePortActionTypes.COMMENCEMENT,
	EstimatePortActionTypes.COMPLETION,
	EstimatePortActionTypes.DELIVERY,
	EstimatePortActionTypes.DRY_DOCKING,
	EstimatePortActionTypes.PASSING,
	EstimatePortActionTypes.REDELIVERY,
	EstimatePortActionTypes.REPOSITIONING,
	EstimatePortActionTypes.WAITING,
];

// We don't want to show ALL actions, only ones related to itinerary planning
export const purposesToShow = [
	PortActionTypes.ARRIVAL,
	PortActionTypes.BUNKER_STEM,
	PortActionTypes.CANAL_TRANSIT,
	PortActionTypes.COMMENCEMENT,
	PortActionTypes.COMPLETION,
	PortActionTypes.DELIVERY,
	PortActionTypes.DEPARTURE,
	PortActionTypes.DISCHARGING,
	PortActionTypes.DRY_DOCKING,
	PortActionTypes.LOADING,
	PortActionTypes.PASSING,
	PortActionTypes.REPOSITIONING,
	PortActionTypes.REDELIVERY,
	PortActionTypes.REDELIVERING_TC_IN,
	PortActionTypes.WAITING,
] as string[];

export const manuallySelectablePurposes = [
	PortActionTypes.DRY_DOCKING,
	PortActionTypes.PASSING,
	PortActionTypes.REPOSITIONING,
	PortActionTypes.WAITING,
] as string[];

export const normalizedPortPurposesToShow = purposesToShow.map((purpose) =>
	purpose.toLowerCase()
);

export const getPortPurposeLabel = (purpose: string) => {
	const matchedKey = Object.values(PortActionTypes).find(
		(value) => value.toLowerCase() === purpose.toLowerCase(),
	);

	return matchedKey != null ?
		PortActionTypeLabels[matchedKey as keyof typeof PortActionTypeLabels] ?? matchedKey :
		purpose;
};